import en from './en';

const enConfig = { en };

export default enConfig;
